import React from 'react'

import { URLS } from '../../../_config'
import { useNavigate, useParams } from 'react-router-dom'
import parse from 'html-react-parser'
import { trackEvent } from '../../../_common/functions'
interface DomainCardProps {
    templateid: string
    icon: any
    label: string
    variant?: 'black' | 'yellow'
}
const DomainCard: React.FC<DomainCardProps> = ({ icon, label, variant = 'yellow', templateid }) => {
    const navigate: any = useNavigate()
    const params: any = useParams()
    const bgColor = variant === 'black' ? 'bg-[#030303]' : 'bg-[#f5e003]'
    const textColor = variant === 'black' ? 'text-white' : 'text-[#0d121c]'

    console.log('Rendering DomainCard with variant:', variant) // Debugging line to check the variant value
    const redirectTempplate = (key: string) => {
        console.log('Redirecting to template with key:', key) // Debugging line to check the key value
        trackEvent('template_domain_switched', { from_domain: params?.templateid, to_domain: key })
        navigate(URLS.PREEXISTING_TEMPLATE_LIST(key))
    }

    return (
        <button type="button" onClick={() => redirectTempplate(templateid)} className={`${bgColor} relative rounded-[0.625rem] w-[18.167rem] h-[4.333rem] flex items-center justify-center overflow-hidden cursor-pointer`}>
            {variant === 'yellow' && <div aria-hidden="true" className="absolute border border-[#d6d6d6] border-solid inset-0 pointer-events-none rounded-[0.625rem]" />}
            <div className="flex gap-[0.833rem] items-start px-[15px] py-[0.833rem] relative w-full ">
                <div className={`flex items-center justify-center shrink-0 ${textColor} template-icon-small !text-[2.5rem]`}>{parse(icon || '')}</div>
                <div className="flex flex-[1_0_0] flex-col items-start justify-center min-h-px min-w-px relative self-stretch">
                    <p className={`font-['Poppins:Medium',sans-serif] text-[0.833rem] leading-[1rem] ${textColor}`}>{label}</p>
                </div>
            </div>

            <div className="absolute  size-[180px] right-[-4rem] top-[1.5rem] pointer-events-none">
                <svg fill="none" preserveAspectRatio="none" viewBox="0 0 267 267" width="6rem" aria-hidden="true">
                    <path
                        d="M267 133.5C267 207.23 207.23 267 133.5 267C59.77 267 0 207.23 0 133.5C0 59.77 59.77 0 133.5 0C207.23 0 267 59.77 267 133.5ZM48.1473 133.5C48.1473 180.639 86.361 218.853 133.5 218.853C180.639 218.853 218.853 180.639 218.853 133.5C218.853 86.361 180.639 48.1473 133.5 48.1473C86.361 48.1473 48.1473 86.361 48.1473 133.5Z"
                        fill={variant === 'yellow' ? '#E5B611' : '#ffffff'}
                        fillOpacity="0.3"
                    />
                </svg>
            </div>
        </button>
    )
}

export default DomainCard
